import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../../../store";
import { createIncidentReport } from "../../../../../../acions/incidentReports";

export const useSave = (
  form: FormInstance,
  close: () => void,
  reloadData: () => void,
) => {
  const dispatch = useAppDispatch();

  const [isSaving, setIsSaving] = useState<boolean>(false);

  const { accountId } = useParams();

  const save = useCallback(
    async (isAddNew: boolean) => {
      try {
        const request = await form.validateFields();

        request.contractId = accountId || request.contractNumber;

        setIsSaving(true);

        await Promise.resolve(dispatch(createIncidentReport(request)));

        setIsSaving(false);

        reloadData();

        isAddNew ? form.resetFields() : close();
      } catch {
        setIsSaving(false);
      }
    },
    [accountId, dispatch, form, close, reloadData],
  );

  return { isSaving, save };
};
